import { Component, OnInit, OnDestroy } from '@angular/core';
import { CoursewareService } from 'src/services/CoursewareService';
import { SitemapModel } from 'src/model/SiteMapModel';
import { AlertService } from '../_alert';
import { Error } from 'src/model/Error';
import { Title } from '@angular/platform-browser';
import { MetaService } from 'src/services/MetaService';
import { Router } from '@angular/router';

@Component({
  selector: 'app-site-map',
  templateUrl: './site-map.component.html',
  styleUrls: ['./site-map.component.css']
})
export class SiteMapComponent implements OnInit, OnDestroy{
  public siteMap: SitemapModel;
  public retrieved: boolean = false;

  constructor(private _router: Router, private canonicalService: MetaService, private titleService: Title, private coursewareService: CoursewareService,private alertService: AlertService) { 
    this.titleService.setTitle("Site Map - Lawshelf Educational Media");
  }

  ngOnDestroy(): void {
    this.canonicalService.removeCanonicalURL();
  }

  ngOnInit() {
    this.canonicalService.createCanonicalURL(this._router.url, "/sitemapview/");
    this.coursewareService.getTableOfContents().subscribe(data => {
      this.siteMap = data; 
      this.retrieved = true;
      if (!this.siteMap.ArticleTopics){
        this.siteMap = null;
        let error: Error = data;
        this.alertService.error(error.Message);
      }
    });
  }

  getRetrievedStyle()
  {
    if (!this.retrieved)
      return "inline";
    return "none"
  }

}
